var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"ui-toast-list component",attrs:{"name":"slide","tag":"div"}},_vm._l((_vm.toastsList),function(item){return _c('UiToast',{key:item.id,attrs:{"item":item},on:{"remove":_vm.onRemove}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }